export const LIGHTBOX_IMAGES_SET_CURRENT_IMAGE = 'LIGHTBOX_IMAGES_SET_CURRENT_IMAGE';
export const LIGHTBOX_IMAGES_SHOW = 'LIGHTBOX_IMAGES_SHOW';
export const LIGHTBOX_IMAGES_NEXT = 'LIGHTBOX_IMAGES_NEXT';
export const LIGHTBOX_IMAGES_PREVIOUS = 'LIGHTBOX_IMAGES_PREVIOUS';

export const setCurrentIndex = (index, iframe, view360) => ({
    type: LIGHTBOX_IMAGES_SET_CURRENT_IMAGE,
    payload: {
        index,
        iframe,
        view360
    }
})

export const show = (visible) => {
    if(visible) {
        if(!document.body.classList.contains('lock-scroll')) {
            document.body.classList.add('lock-scroll')
        }
    } else {
        if(document.body.classList.contains('lock-scroll')) {
            document.body.classList.remove('lock-scroll')
        }
    }

    return {
        type: LIGHTBOX_IMAGES_SHOW,
        payload: {
            visible,
        }
    };
}

export const next = () => ({
    type: LIGHTBOX_IMAGES_NEXT,
})

export const previous = () => ({
    type: LIGHTBOX_IMAGES_PREVIOUS,
})